import { render } from "./ClockDrawingScoring.vue?vue&type=template&id=53b2cc14&scoped=true"
import script from "./ClockDrawingScoring.vue?vue&type=script&lang=js"
export * from "./ClockDrawingScoring.vue?vue&type=script&lang=js"

import "./ClockDrawingScoring.vue?vue&type=style&index=0&id=53b2cc14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b2cc14"]])

export default __exports__